<script setup lang="ts">
import { defineRule, Field as VeeField, Form as VeeForm } from 'vee-validate'

import { emailValidator, requiredValidator } from '@/utils/rulesOfValidate'

import { useAppStore } from '@/store/app/app'
import { SnackbarType } from '@/store/app/app.types'
import { useUserStore } from '@/store/user/user'

import { Success } from '@/api/results'

const { isMobile } = useDevice()

const { changeInfo } = useUserStore()
const { showSnackbar } = useAppStore()

const email = ref('')

defineRule('email', emailValidator)
defineRule('required', requiredValidator)

const saveEmail = async () => {
  const result = await changeInfo({
    email: email.value,
  })

  if (result instanceof Success) {
    showSnackbar({
      message: 'Изменения сохранены',
      type: SnackbarType.SUCCESS,
    })

    return
  }

  showSnackbar({
    message: 'Что-то пошло не так, попробуйте позже',
    type: SnackbarType.MESSAGE,
  })
}
</script>

<template>
  <vee-form v-slot="{ handleSubmit }" class="email-factoid">
    <div class="email-factoid__info">
      <div class="email-factoid__title">
        Узнавай о промокодах и акциях быстрее всех!
      </div>

      <p class="email-factoid__text">
        Все самое вкусное и выгодное в наших рассылках. Нажимая на кнопку, вы
        даете согласие на обработку персональных данных
      </p>
    </div>

    <div class="email-factoid__input">
      <vee-field
        v-slot="{ field, errors }"
        name="E-mail"
        rules="email|required"
        value=""
      >
        <the-input
          v-model="email"
          v-bind="field"
          autocomplete="off"
          placeholder="Введите e-mail"
          hide-details
          :error-messages="errors"
        />
      </vee-field>
    </div>

    <div class="email-factoid__button">
      <the-button
        type="button"
        block
        :radius="isMobile ? 'lg' : 'sm'"
        @click="handleSubmit(saveEmail)"
      >
        Продолжить
      </the-button>
    </div>
  </vee-form>
</template>

<style lang="scss" scoped>
.email-factoid {
  display: flex;
  gap: 0 30px;
  align-items: center;
  width: 100%;
  padding: 30px;
  background:
    url('@/assets/images/email-factoid-background.webp') right bottom no-repeat,
    var(--ui-grey);
  border-radius: 20px;

  @include media('<desktop-mini') {
    display: grid;
    grid-template-rows: max-content max-content;
    gap: 0 36px;
    background: var(--ui-grey);
  }

  @include media('<tablet') {
    display: grid;
  }

  &__info {
    max-width: 50%;

    @include media('<desktop-mini') {
      grid-area: 1 / 1 / 2 / 3;
      max-width: 90%;
    }

    @include media('<tablet') {
      grid-area: 1 / 1 / 2 / 2;
    }
  }

  &__title {
    margin-bottom: 5px;
    font-size: 22px;
    font-weight: 900;
    line-height: 26px;

    @include media('<desktop-mini') {
      margin-bottom: 20px;
    }

    @include media('<tablet') {
      font-size: 20px;
      line-height: 23px;
    }
  }

  &__text {
    font-size: 14px;
    font-weight: 600;
    line-height: 16px;

    @include media('<desktop-mini') {
      margin-bottom: 25px;
    }

    @include media('<tablet') {
      font-size: 12px;
      line-height: 14px;
    }
  }

  &__input {
    width: 216px;

    //TODO Добавить белый цвет для инпута в ЮИ кит, или дождаться макетов новой страницы, где он не будет нужен
    :deep(.app-input__control) {
      background-color: var(--ui-white);
    }

    @include media('<desktop-mini') {
      grid-area: 2 / 1 / 3 / 2;
      width: 273px;
    }

    @include media('<tablet') {
      grid-area: 2 / 1 / 3 / 2;
      width: 100%;
      margin-bottom: 25px;
    }
  }

  &__button {
    width: 170px;

    @include media('<desktop-mini') {
      grid-area: 2 / 2 / 3 / 3;
    }

    @include media('<tablet') {
      grid-area: 3 / 1 / 4 / 2;
      width: 100%;
    }
  }
}
</style>
